import { render, staticRenderFns } from "./AffiliateNewsPopup.vue?vue&type=template&id=1c3b5602&scoped=true&"
import script from "./AffiliateNewsPopup.vue?vue&type=script&lang=js&"
export * from "./AffiliateNewsPopup.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateNewsPopup.vue?vue&type=style&index=0&id=1c3b5602&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b5602",
  null
  
)

export default component.exports